const defaults = {
  cartModal: ".js-ajax-cart-modal", // classname
  cartModalContent: ".js-ajax-cart-modal-content", // classname
  cartModalClose: ".js-ajax-cart-modal-close", // classname
  cartDrawer: ".js-ajax-cart-drawer", // classname
  cartDrawerContent: ".js-ajax-cart-drawer-content", // classname
  cartDrawerClose: ".js-ajax-cart-drawer-close", // classname
  cartDrawerTrigger: ".js-ajax-cart-drawer-trigger", // classname
  cartOverlay: ".js-ajax-cart-overlay", // classname
  cartCounter: ".js-ajax-cart-counter", // classname
  addToCart: ".js-ajax-add-to-cart", // classname
  removeFromCart: ".js-ajax-remove-from-cart", //classname
  removeFromCartNoDot: "js-ajax-remove-from-cart", //classname,
  checkoutButton: ".js-ajax-checkout-button",
  continueButton: ".button--continue",
};

const cartModal = document.querySelector(defaults.cartModal);
const cartModalContent = document.querySelector(defaults.cartModalContent);
const cartModalClose = document.querySelector(defaults.cartModalClose);
const cartDrawer = document.querySelector(defaults.cartDrawer);
const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
const cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
const cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
const cartOverlay = document.querySelector(defaults.cartOverlay);
const cartCounter = document.querySelector(defaults.cartCounter);
const addToCart = document.querySelectorAll(defaults.addToCart);
let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
const checkoutButton = document.querySelector(defaults.checkoutButton);
const continueButton = document.querySelector(defaults.continueButton);
const htmlSelector = document.documentElement;

// Handle variant size
if ($(".pdp-upgrade-v2.has_size").length == 1) {
  $(".size_select li").not(".disabled").first().addClass("active_size");

  let size_first = $(".active_size").attr("value");

  $(".product-form__buttons.has_size button").attr("data-value", size_first);

  $('ul[name="id"] li:not(.disabled)').on("click", function (e) {
    $('ul[name="id"] li:not(.disabled)').removeClass("active_size");
    $('ul[name="id"] li:not(.disabled)').removeClass("choose_size");
    $(this).addClass("choose_size");

    let dataSize = $(this).attr("value");
    $(this)
      .parents("body")
      .find(".js-ajax-add-to-cart.has_size")
      .attr("data-value", dataSize);
  });
}

for (let i = 0; i < addToCart.length; i++) {
  addToCart[i].addEventListener("click", function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    // console.log(addToCart[i]);
    if ($(this).hasClass("has_size")) {
      const selectSize = document.querySelector('select.select-size');
      let formID1 = null;
      
      if (selectSize) {
        formID1 = selectSize.value;
        
        if (!formID1 || formID1 === '') {
          const selectedOption = selectSize.options[selectSize.selectedIndex];
          if (selectedOption && !selectedOption.disabled && selectedOption.value) {
            formID1 = selectedOption.value;
            selectSize.value = formID1; // Ensure select reflects this value
          }
        }
        
        if (!formID1 || formID1 === '') {
          const firstAvailableOption = selectSize.querySelector('option:not([disabled])');
          if (firstAvailableOption && firstAvailableOption.value) {
            formID1 = firstAvailableOption.value;
            selectSize.value = formID1; // Set it as selected
          }
        }
        
        // Update button's data-value to match current select value
        if (formID1) {
          $(this).attr("data-value", formID1);
        }
      } else {
        formID1 = $(this).attr("data-value");
      }
      
      // Validate before proceeding
      if (!formID1 || formID1 === 'null' || formID1 === 'undefined' || formID1 === '') {
        // console.error('No variant ID found. Please select a size.');
        alert('Please select a size before adding to cart.');
        return;
      }
      
      // Additional validation: check if it's a valid number
      const variantIdNum = parseInt(formID1);
      if (isNaN(variantIdNum) || variantIdNum <= 0) {
        // console.error('Invalid variant ID format:', formID1);
        alert('Invalid variant selected. Please refresh the page and try again.');
        return;
      }
      
      const span = addToCart[i].querySelector("span");
      const buttonText = span ? span.textContent.trim() : addToCart[i].textContent.trim();
      
      if (span) {
        span.innerHTML = "Adding...";
        addProductToCartSize(formID1, span, buttonText || "Add to Cart");
      } else {
        addToCart[i].innerHTML = "Adding...";
        addProductToCartSize(formID1, addToCart[i], buttonText || "Pre-Order Now");
      }
    } else {
      const formID = this.parentNode.getAttribute("id");
      // console.log(formID);
      const span = addToCart[i].querySelector("span");
      if (span) {
        span.innerHTML = "Adding...";
        addProductToCart(formID, span, "Add to Cart");
      } else {
        addToCart[i].innerHTML = "Adding...";
        addProductToCart(formID, addToCart[i], "Pre-Order Now");
      }
      // console.log('Tesst click 1', formID)
    }
  });
}

/* Product bundles by Mageworx */
function hasProductAddons() {
  const mwProductAddons = document.querySelector("mw-product-addons");
  console.log(mwProductAddons);
  if (mwProductAddons?.shadowRoot) {
    const el = mwProductAddons.shadowRoot.querySelector(".ProductAddons");
    const exists = el !== null;
    return {
      exists,
      element: el,
    };
  }
  return {
    exists: false,
    element: null,
  };
}

/* Product bundles by Mageworx */

async function addProductToCartSize(formID1, addToCartEl, text) {
  try {
    if (!formID1 || formID1 === 'null' || formID1 === 'undefined') {
      addToCartFail(new Error('Please select a size'), addToCartEl, text);
      return;
    }

    const variantId = parseInt(formID1);
    if (isNaN(variantId) || variantId <= 0) {
      addToCartFail(new Error('Invalid variant selected'), addToCartEl, text);
      return;
    }

    // ✅ Check if variant already exists in cart — if yes, update quantity instead
    const cart = await fetch("/cart.js", { cache: "no-store" }).then(r => r.json());
    const existingItem = cart.items.find(item => item.variant_id === variantId);

    if (existingItem) {
      // Update quantity instead of adding duplicate
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: existingItem.key, quantity: existingItem.quantity + 1 }),
      });
    } else {
      // Add new item
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.description || errorData.message || `Failed to add to cart (${response.status})`);
      }
    }

    const updatedCart = await fetch("/cart.js", { cache: "no-store" }).then(r => r.json());
    const product = updatedCart.items.find(item => item.variant_id === variantId) || updatedCart.items[0];
    await addToCartOk(product, null, addToCartEl, text);

  } catch (error) {
    console.error('addProductToCartSize error:', error);
    addToCartFail(error, addToCartEl, text);
  }
}

async function addProductToCart(formID, addToCart, text) {
  /* Product bundles by Mageworx */
  // console.log($("#" + formID).serialize());

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: $("#" + formID).serialize(),
    });

    if (!response.ok) throw new Error("Network response was not ok");

    const product = await response.json();
    // console.log(product);
    const params = new URLSearchParams($("#" + formID).serialize());
    const id = params.get("id");

    await addToCartOk(product, id, addToCart, text);
  } catch (error) {
    addToCartFail(error, addToCart, text);
  }
}


async function addToCartOk(product, id = null, addToCartEl, text) {
  // Reset button immediately
  addToCartEl.innerHTML = text;

  // Track item for category events
  const categoryList = jQuery(".collection_title .breadcrumbs__link:first-child span")
    .text()
    .replace(/\s+/g, " ");
  const showList = [{ id: product.key, categoryName: categoryList }].concat(
    JSON.parse(localStorage.getItem("showList") || "[]")
  );
  localStorage.setItem("showList", JSON.stringify(showList));

  // Handle Mageworx product addons
  const { exists, element } = hasProductAddons();
  if (exists && id) {
    const selectedItems = element.querySelectorAll(".ItemSelected");
    const all = [];
    for (const item of selectedItems) {
      const imageBlock = item.querySelector(".ProductAddons__ImageBlock");
      if (imageBlock) {
        const link = imageBlock.querySelector("a");
        if (link) {
          const lastSegment = link.href.split("/").filter(Boolean).pop();
          const addonProduct = await fetchProductByHandle(lastSegment);
          if (addonProduct?.variants?.length) {
            all.push(addSingleVariantToCart(addonProduct.variants[0].id));
          }
        }
      }
    }
    await Promise.all(all);
  }

  // ✅ Open drawer AND update cart at exactly the same time
  await Promise.all([
    openFullCartDrawer(),
    onFullCartUpdate().catch((err) => console.error("Cart drawer update failed:", err))
  ]);
}
async function fetchProductByHandle(handle) {
  return await fetch(`/products/${handle}.js`)
    .then((res) => {
      if (!res.ok) throw new Error("Product not found");
      return res.json();
    })
    .then((product) => {
      // console.log("Product Title:", product.title);
      // console.log("Variants:", product.variants);
      return product;
    })
    .catch((err) => {
      console.error("Error loading product:", err);
    });
}
async function addSingleVariantToCart(variantId, quantity = 1) {
  try {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
      }),
    });

    if (!res.ok) throw new Error("Add to cart failed");

    const data = await res.json();
    // console.log("Added to cart:", data);
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const itemCount = cart.item_count;
        cartCounter.innerHTML = cart.item_count;
        // Remove hidden class if cartCounter > 0
        if (Number(cartCounter.innerHTML) > 0) {
          cartCounter.classList.remove("hidden");
          cartCounter.classList.add("visible");
        }
      });
    return data;
  } catch (error) {
    console.error("Error adding single variant:", error);
  }
}

async function fetchCart(product = null) {
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: async function (cart) {
      // onFullCartUpdate() will handle rendering the cart drawer
      // So we don't need to call renderCart() which uses the old minicart
      await onFullCartUpdate();
      onCartUpdate(cart, product);

      // Only update checkout button visibility
      if (cart.item_count === 0) {
        if (checkoutButton) {
          checkoutButton.classList.add("is-hidden");
        }
        // Old minicart - keep for backward compatibility
        if (cartDrawerContent) {
          cartDrawerContent.innerHTML = "Cart is empty";
        }
      } else {
        if (checkoutButton) {
          checkoutButton.classList.remove("is-hidden");
        }
        // Don't call renderCart() as onFullCartUpdate() handles the new cart drawer
        // renderCart(cart); // Commented out - using onFullCartUpdate() instead
      }
    },
  });
}

function changeItem(line, quantity = 0, callback) {
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=" + quantity + "&line=" + line,
    dataType: "json",
    success: async function (cart) {
      if (typeof callback === "function") {
        callback(cart);
      } else {
        await fetchCart();
        removeProductFromCart();
      }
    },
  });
}

function onCartUpdate(cart, product = null) {
  // Disable this logic as it's causing issues when adding different variants
  // This function was trying to remove duplicate items, but it was incorrectly
  // removing items when adding new variants of the same product
  // Shopify handles duplicate variants automatically by increasing quantity
  
  // Commented out to prevent removing items when adding different variants
  /*
  const arrId = [];
  const arrProperties = [];
  const productJson = JSON.stringify(product);
  const arrPrd = JSON.parse(productJson);
  cart.items.forEach(function (item, index) {
    arrId.push(item.id);
    const propertiesItem = item.properties;
    if (
      propertiesItem &&
      Object.keys(propertiesItem).length === 1 &&
      Object.getPrototypeOf(propertiesItem) === Object.prototype
    ) {
      arrProperties.push(JSON.stringify(item.properties));
    }
  });
  if (arrPrd) {
    if (arrId.includes(arrPrd.id)) {
      let quantity = 0;
      let line = 0;
      if (
        arrPrd.properties &&
        arrProperties.includes(JSON.stringify(arrPrd.properties))
      ) {
        let currentItemCheckNotPre = document.getElementById(arrPrd.id);
        if (
          typeof currentItemCheckNotPre !== "undefined" &&
          currentItemCheckNotPre !== null
        ) {
          // quantity = document.querySelector(arrPrd.id+' .ajax-cart-item__single').textContent;
          line = parseInt(currentItemCheckNotPre.getAttribute("data-line"));
          // changeItem(line,quantity);
          changeItem(parseInt(line + 1), quantity);
        }
      } else {
        let currentItemCheckPre = document.getElementById(
          "pre_order" + arrPrd.id
        );
        if (
          typeof currentItemCheckPre !== "undefined" &&
          currentItemCheckPre !== null
        ) {
          // quantity = document.querySelector('pre_order'+arrPrd.id+' .ajax-cart-item__single').textContent;
          line = parseInt(currentItemCheckPre.getAttribute("data-line"));
          // changeItem(line,quantity);
          changeItem(parseInt(line + 1), quantity);
        }
      }
    }
  }
  */
  
  // Just log for debugging
  if (product) {
    // console.log("onCartUpdate called with product:", {
    //   id: product.id,
    //   variant_id: product.variant_id,
    //   title: product.title,
    //   key: product.key
    // });
  }
  // console.log("Cart now has", cart.items.length, "items");
}

function removeProductFromCart() {
  cartCounter.innerHTML = Number(cartCounter.innerHTML) - 1;
  // Remove hidden class if cartCounter > 0
  if (Number(cartCounter.innerHTML) > 0) {
    cartCounter.classList.remove("hidden");
    cartCounter.classList.add("visible");
  } else {
    cartCounter.classList.add("hidden");
    cartCounter.classList.remove("visible");
  }
}

function addToCartFail(error, addToCart, text) {
  if (cartModalContent) {
    cartModalContent.innerHTML =
      "The product you are trying to add is out of stock.";
  }
  // Restore button text on error
  if (addToCart && text) {
    if (addToCart.tagName === "SPAN") {
      addToCart.innerHTML = text;
    } else {
      addToCart.innerHTML = text;
    }
  }
  // openAddModal();
  // openCartOverlay();
}

function renderCart(cart) {
  clearCartDrawer();
  cart.items.forEach(function (item, index) {
    //console.log(item.title);

    const productTitle =
      '<div class="ajax-cart-item__title">' + item.product_title + "</div>";
    let imgPrd = item.image;
    if (item.image == null) {
      imgPrd =
        "//cdn.shopify.com/s/files/1/0562/7648/4141/t/22/assets/placeholder-images-image_large.png?v=14594405247086941604";
    }
    const productImage =
      '<img class="ajax-cart-item__image" src="' + imgPrd + '" >';
    const productPrice =
      '<div class="ajax-cart-item__price">' +
      "$" +
      parseFloat(item.line_price / 100).toFixed(2) +
      "</div>";
    const productQuantity =
      '<div class="ajax-cart-item__quantity">' + item.quantity + "</div>";
    let styleVariant = "";
    if (item.variant_title == null) {
      styleVariant = 'style="display:none;"';
    }
    const productVariant =
      '<div class="ajax-variant-color" ' +
      styleVariant +
      "><span>" +
      item.options_with_values[0].name +
      ":</span>" +
      item.variant_title +
      "</div>";
    const productRemove =
      '<div class="ajax-cart-item__remove ' +
      defaults.removeFromCartNoDot +
      '" data-id="' +
      item.id +
      '">x</div>';
    let preOrder = item.id;
    const propertiesItem = item.properties;

    if (
      propertiesItem &&
      Object.keys(propertiesItem).length === 1 &&
      Object.getPrototypeOf(propertiesItem) === Object.prototype
    ) {
      preOrder = "pre_order" + item.id;
      // Pre_note = '<div class="ajax-cart-preorder_note">' + 'Note: Pre-order success' + '</div>';
    }
    // else {
    //     Pre_note = "";
    // }

    const concatProductInfo =
      '<div id="' +
      preOrder +
      '" class="ajax-cart-item__single" data-id="' +
      preOrder +
      '" data-line="' +
      Number(index + 1) +
      '">' +
      '<div class="image">' +
      productImage +
      "</div>" +
      '<div class="content-minicart">' +
      productTitle +
      productVariant +
      productPrice +
      productQuantity +
      productRemove +
      "</div></div>";

    cartDrawerContent.innerHTML =
      cartDrawerContent.innerHTML + concatProductInfo;
  });

  // document.querySelectorAll('.js-ajax-remove-from-cart')
  //     .forEach((element) => {
  //         element.addEventListener('click', function() {
  //             const lineID = this.parentNode.getAttribute('data-line');
  //             console.log('aa');
  //         });
  //     });

  // removeFromCart = document.querySelector(defaults.removeFromCart);

  // Fix action remove in minicart
  $(".js-ajax-remove-from-cart").on("click", function () {
    const line = this.closest(".ajax-cart-item__single").getAttribute(
      "data-line"
    );
    // console.log("Remove tesst", line)
    changeItem(line, 0);
  });
}

function openCartDrawer() {
  cartDrawer.classList.add("is-open");
}

function closeCartDrawer() {
  cartDrawer.classList.remove("is-open");
}

function clearCartDrawer() {
  cartDrawerContent.innerHTML = "";
}

function openAddModal() {
  cartModal.classList.add("is-open");
}

function closeAddModal() {
  cartModal.classList.remove("is-open");
}

// Click out side remove popup minicart
$(document).on("click", function (event) {
  if (!$(event.target).closest(".js-ajax-cart-drawer-trigger").length) {
    closeCartDrawer();
  }
});

// hover show minicart
// if ($(window).width() > 1025) {
//   $(".js-ajax-cart-drawer-trigger").mouseover(function () {
//     cartDrawer.classList.add("is-open");
//   });

//   $(".js-ajax-cart-drawer").hover(
//     function () {
//       cartDrawer.classList.add("is-open");
//     },
//     function () {
//       cartDrawer.classList.remove("is-open");
//     }
//   );
// }

function openCartOverlay() {
  cartOverlay.classList.add("is-open");
  htmlSelector.classList.add("is-locked");
}

function closeCartOverlay() {
  cartOverlay.classList.remove("is-open");
  htmlSelector.classList.remove("is-locked");
}

// cartModalClose.addEventListener("click", function () {
//   closeAddModal();
//   closeCartOverlay();
// });

cartDrawerClose.addEventListener("click", function () {
  closeCartDrawer();
  closeCartOverlay();
});
// cart is empty stanje
cartOverlay.addEventListener("click", function () {
  closeAddModal();
  closeCartDrawer();
  closeCartOverlay();
});

// cartDrawerTrigger.addEventListener("click", function (event) {
//   event.preventDefault();
//   //fetchCart();
//   if (window.screen.width > 1024) {
//     openCartDrawer();
//     openCartOverlay();
//   }
// });
continueButton.addEventListener("click", function (event) {
  closeCartDrawer();
  closeCartOverlay();
});

function openFullCartDrawer() {
  const cartDrawerEl = document.querySelector("cart-drawer");
  const cartDrawerItems = document.querySelector("cart-drawer-items");
  
  // ✅ Show skeleton immediately while fetch is in progress
  if (cartDrawerItems) {
    cartDrawerItems.innerHTML = `
      <div style="padding: 20px; display: flex; flex-direction: column; gap: 16px;">
        ${[1,2].map(() => `
          <div style="display: flex; gap: 12px; align-items: center;">
            <div style="width: 80px; height: 80px; background: #e0e0e0; border-radius: 4px; flex-shrink: 0;
              background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
              background-size: 200% 100%; animation: shimmer 1.2s infinite;">
            </div>
            <div style="flex: 1; display: flex; flex-direction: column; gap: 8px;">
              <div style="height: 14px; background: #e0e0e0; border-radius: 4px; width: 70%;
                background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
                background-size: 200% 100%; animation: shimmer 1.2s infinite;"></div>
              <div style="height: 12px; background: #e0e0e0; border-radius: 4px; width: 40%;
                background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
                background-size: 200% 100%; animation: shimmer 1.2s infinite;"></div>
            </div>
          </div>
        `).join('')}
      </div>
      <style>
        @keyframes shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
      </style>
    `;
  }

  cartDrawerEl.classList.add("active");
  document.querySelector("body").classList.add("overflow-hidden");
}

document.addEventListener("DOMContentLoaded", async function () {
  await fetchCart();
});

// --- Cart drawer section refresh (single source of truth) ---
// NOTE: Uses /cart?section_id=cart-drawer rather than routes.cart_update_url
// ("/cart/update"). The non-.js /cart/update route does not support
// section_id rendering on GET, so it silently returns the wrong payload
// and the drawer replace step below would no-op (see incident: cart drawer
// stuck on loading skeleton, fixed by switching to /cart?section_id=...).
async function onFullCartUpdate() {
  try {
    const timestamp = new Date().getTime();
    const random = Math.random().toString(36).substring(7);
    const url = `/cart?section_id=cart-drawer&t=${timestamp}&r=${random}`;

    const response = await fetch(url, {
      method: "GET",
      cache: "no-store",
      headers: {
        "Cache-Control": "no-cache, no-store, must-revalidate",
        "Pragma": "no-cache",
        "Expires": "0"
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status} for URL: ${url}`);
    }

    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, "text/html");

    const sourceCartDrawerItems = html.querySelector("cart-drawer-items");
    const targetCartDrawerItems = document.querySelector("cart-drawer-items");

    if (!sourceCartDrawerItems) {
      console.error("[ajax-cart] 'cart-drawer-items' not found in fetched section HTML. Check section_id/url:", url);
    }
    if (!targetCartDrawerItems) {
      console.error("[ajax-cart] 'cart-drawer-items' not found in current page DOM.");
    }

    const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
    for (const selector of selectors) {
      const targetElement = document.querySelector(selector);
      const sourceElement = html.querySelector(selector);
      if (targetElement && sourceElement) {
        const clonedSource = sourceElement.cloneNode(true);
        targetElement.replaceWith(clonedSource);
      } else if (!sourceElement) {
        console.error(`[ajax-cart] Selector "${selector}" missing from fetched section HTML.`);
      }
    }

    // Reinitialize scripts in the new content
    const scripts = document.querySelector("cart-drawer-items")?.querySelectorAll("script");
    if (scripts) {
      scripts.forEach((oldScript) => {
        const newScript = document.createElement("script");
        Array.from(oldScript.attributes).forEach((attr) => {
          newScript.setAttribute(attr.name, attr.value);
        });
        newScript.appendChild(document.createTextNode(oldScript.innerHTML));
        oldScript.parentNode?.replaceChild(newScript, oldScript);
      });
    }

    // Update empty state
    const cartDrawerItems = document.querySelector("cart-drawer-items");
    const cartDrawer = document.querySelector("cart-drawer");

    if (cartDrawerItems && cartDrawer) {
      if (!cartDrawerItems.classList.contains("is-empty")) {
        if (cartDrawer.classList.contains("is-empty")) {
          cartDrawer.classList.remove("is-empty");
          const emptyInner = document.querySelector(".drawer__inner-empty");
          if (emptyInner) emptyInner.style.display = "none";
        }
        // Always sync the counter from the live cart, regardless of is-empty
        // state transition above (fixes: counter stuck at 0 on first add,
        // only correcting itself after a manual page refresh).
        try {
          const liveCart = await fetch("/cart.js", { cache: "no-store" }).then(r => r.json());
          const cartCounter = document.querySelector(".js-ajax-cart-counter");
          if (cartCounter) {
            cartCounter.innerHTML = liveCart.item_count;
            if (liveCart.item_count > 0) {
              cartCounter.classList.remove("hidden");
              cartCounter.classList.add("visible");
            }
          }
        } catch (e) {
          console.error("[ajax-cart] Failed to sync cart counter:", e);
        }
      } else {
        if (!cartDrawer.classList.contains("is-empty")) {
          cartDrawer.classList.add("is-empty");
          const emptyInner = document.querySelector(".drawer__inner-empty");
          if (emptyInner) emptyInner.style.display = "flex";
          const cartCounter = document.querySelector(".js-ajax-cart-counter");
          if (cartCounter) {
            cartCounter.classList.add("hidden");
            cartCounter.innerHTML = "0";
          }
        }
      }
    }

    document.dispatchEvent(new CustomEvent("cart:updated", {
      detail: { source: "onFullCartUpdate" }
    }));
  } catch (e) {
    console.error("[ajax-cart] Error updating cart drawer:", e);
    throw e;
  }
}